import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from "@angular/core";
import {VisitPlanFacadeService} from "../../services/visit-plan-facade.service";
import {VisitScheduleAgentImportOptionModel} from "../../../models/visit-schedule-agent-import-option.model";
import {Subscription} from "rxjs";
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";

require('./visit-plan-external-agents-resource-holders-list.scss');
@Component({
  standalone: false,
  selector: 'app-visit-plan-external-agents-resource-holders-list',
  templateUrl: './visit-plan-external-agents-resource-holders-list.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VisitPlanExternalAgentsResourceHoldersList implements OnInit, OnDestroy {

  @Input() visitPlanId: string;
  @Input() visitScheduleId: string;

  @Output() onSelectionChange = new EventEmitter<string[]>();
  @Output() onSelectAgentId = new EventEmitter<string>();

  @ViewChild(CdkVirtualScrollViewport) private viewport: CdkVirtualScrollViewport;

  public queryString: string = '';
  public options: VisitScheduleAgentImportOptionModel[] = [];
  public optionsToDisplay: VisitScheduleAgentImportOptionModel[] = [];
  public isLoading: boolean = false;
  public selectedAgentIdsMap: { [key: string]: boolean } = {};
  public cursor: string | undefined;

  private sub: Subscription;

  constructor(
    @Inject(VisitPlanFacadeService) private visitPlanFacadeService: VisitPlanFacadeService,
    @Inject(ChangeDetectorRef) private cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit() {
    this._getAgents();
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }

  onQueryChange(query: string) {
    this.queryString = query;
    this._getAgents(true);
  }

  onSelectAgent(agentId: string) {
    this.selectedAgentIdsMap[agentId] = !this.selectedAgentIdsMap[agentId];
    this.onSelectAgentId.emit(agentId);
    this._emitSelection();
  }

  private _emitSelection() {
    const selectedIds = Object.keys(this.selectedAgentIdsMap).filter(id => this.selectedAgentIdsMap[id]);
    this.onSelectionChange.emit(selectedIds);
  }

  getNextBatch() {
    if (this.isLoading || !this.cursor) return;
    if (this.viewport.measureScrollOffset('bottom') < 50) {
      this._getAgents();
    }
  }

  private _getAgents(reset: boolean = false) {
    if (reset) {
      this.cursor = undefined;
      this.options = [];
      this.optionsToDisplay = [];
    }

    this.isLoading = true;
    this.cdr.detectChanges();

    const params: any = {
      limit: 100
    };

    if (this.cursor) {
      params.cursor = this.cursor;
    }

    if (this.queryString) {
      params.query = this.queryString;
    }

    this.sub?.unsubscribe();
    this.sub = this.visitPlanFacadeService.getExternalAgentsResourceHoldersCursor(this.visitPlanId, this.visitScheduleId, params)
      .subscribe({
        next: (res) => {
          this.options = [...this.options, ...res.list];
          this.optionsToDisplay = [...this.options];
          this.cursor = res.cursor;
          this.isLoading = false;
          this.cdr.detectChanges();
        },
        error: () => {
          this.isLoading = false;
          this.cdr.detectChanges();
        }
      });
  }
}
